import {UserModelResponse} from "../models/userResponse.model";
export class Credentials{
  token_date:string;
  userMR:UserModelResponse;

  constructor(token_date:string,userMR:UserModelResponse){
    this.token_date = token_date;
    this.userMR = userMR;
  }

}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/models/credentials.ts